import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#6366F1", // indigo-500
        secondary: "#0F172A", // slate-900
        accent: "#8B5CF6", // violet-500
        info: "#0EA5E9", // sky-500
        success: "#10B981", // emerald-500
        warning: "#F59E0B", // amber-500
        error: "#EF4444", // red-500
        anchor: "#6366F1",
        background: "#F1F5F9", // slate-100
      },
    },
  },
});
